<div class="app-loader-wrapper">
    <div class="app-lds-ring" [ngStyle]="{ width: wrapperSize, height: wrapperSize }">
        <div [ngStyle]="style"></div>
        <div [ngStyle]="style"></div>
        <div [ngStyle]="style"></div>
        <div [ngStyle]="style"></div>
    </div>
</div>